var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./QRCode.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?id=data-v-9408a63e!../../vue-loader/lib/selector?type=template&index=0!./QRCode.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-qrcode-component/src/QRCode.vue
// module id = 38
// module chunks = 0